const Tag = ({ name }) => {
  return <p className="tag">{name}</p>;
};

export default Tag;
